import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export const FOLDERNAME_RULE_TYPES = ["Dynamic", "Static"];

type SelectFoldernameRuleTypeProps = {
  isDisabled?: boolean;
};

export const SelectFoldernameRuleType: React.FC<
  SelectFoldernameRuleTypeProps
> = ({ isDisabled }) => {
  const { t } = useTranslation();

  return (
    <SelectField
      name="type"
      label={t("designMappings.actions.foldernameRules.form.label.type")}
      style={{ width: "100%" }}
      options={FOLDERNAME_RULE_TYPES.map((typeId) => ({
        label: t(`designMappings.actions.foldernameRules.types.${typeId}`),
        value: typeId,
      }))}
      disabled={isDisabled}
    />
  );
};
